module.exports = __webpack_public_path__ + "static/crater-founders-grid-2-a2af13c924c0369dec41d9900a6bf036.png";